import { Component } from '@angular/core';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import { NavigatePage } from '../navigate/navigate';

/**
 * Generated class for the PriemnicaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-priemnica',
  templateUrl: 'priemnica.html',
})
export class PriemnicaPage {

  test = [
    { id: 1, artikle: 'test1' },
    { id: 2, artikle: 'test2' },
    { id: 3, artikle: 'test3' },
    { id: 4, artikle: 'test4' },
    { id: 5, artikle: 'test5' },
    { id: 6, artikle: 'test6' },
  ]

  priv: boolean = false


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, private barcodeScanner: BarcodeScanner, public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PriemnicaPage');
  }

  presentAlert() {
    var _that = this
    let alert = this.alertCtrl.create({
      title: 'Barcode scanner',
      subTitle: _that.dic.l["novprivall"],
      buttons: [_that.dic.l['ok']]
    });
    alert.present();
  }


  Scan() {
    if (this.priv == false) {
      this.presentAlert()
    } else {

      var _that = this;
      this.barcodeScanner.scan().then(barcodeData => {
        // console.log('Barcode data', barcodeData.text);
        if (barcodeData.text != null && barcodeData.text != '') {
          console.log(barcodeData, 'barcodeData')
          alert(barcodeData.text)
          //   if (_that.order.barcode == barcodeData.text) {
          //     _that.orderSavePickuUp(barcodeData.text, 'fromBase')
          //   } else {
          //     let alert = _that.alertCtrl.create({
          //       title: 'Error!',
          //       subTitle: 'You scan wrong barcode !',
          //       buttons: ['OK']
          //     });
          //     alert.present();

          //   }
          // }
        }
      }).catch(err => {
        console.log('Error', err);
      });
    }
  }


  Navigate() {
    //   this.navCtrl.push(NavigatePage)
    // }
    let modal = this.modalCtrl.create(NavigatePage, {
      cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen2" });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/magacin/priemnica/priemnica.ts